import React, { useState } from 'react';
import { motion } from 'framer-motion';

const FAQ = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

const faqs = [
  { 
    id: 1, 
    question: "What is Karungali?", 
    answer: "Karungali (Ebony wood) is a rare type of tree, different from common trees like neem or mango. We use this strong and unique wood to craft our products." 
  },
  { 
    id: 2, 
    question: "What are the benefits of Karungali?", 
    answer: "Karungali products are believed to store cosmic energy, providing a constant flow of positive energy. They help reduce stress and bring balance to the mind and body." 
  },
  { 
    id: 3, 
    question: "What is the original color of Karungali?", 
    answer: "Karungali is naturally black, which is why it is called 'Karungali' in Tamil (meaning black wood). Depending on the tree, the shade may appear dark brown or deep black." 
  },
  { 
    id: 4, 
    question: "Who can use Karungali products?", 
    answer: "Anyone can use Karungali—both men and women, and people of all religions. There are no restrictions." 
  },
  { 
    id: 5, 
    question: "How do you say it is beneficial?", 
    answer: "Many older generations believe Karungali reduces stress, supports well-being, and even brings growth in life and business. While there is no scientific proof, people trust its traditional benefits." 
  },
  // { 
  //   id: 6, 
  //   question: "What are the do's and don'ts of Karungali?", 
  //   answer: "Karungali Mala should not be worn at night. It is usually worn in the morning after bathing. Avoid wearing it when visiting funeral houses. If you do, it must be purified with sambrani smoke or dipped in milk." 
  // },
  { 
    id: 6, 
    question: "Which age groups can wear Karungali?", 
    answer: "Karungali can be worn by anyone—from newborn babies to elderly people—as it is believed to provide positive energy and success at all ages." 
  }
];


  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? -1 : index);
  };

  return (
    <section className="py-6 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-400 via-orange-200 to-yellow-400 relative overflow-hidden">
      
      {/* Background Dots */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 100 100">
          <defs>
            <pattern id="faq-dots" width="20" height="20" patternUnits="userSpaceOnUse">
              <circle cx="10" cy="10" r="1.5" fill="currentColor" className="text-red-600"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#faq-dots)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-3 sm:px-6">
        
        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-6 sm:mb-12"
        >
          <h2 className="text-xl sm:text-3xl md:text-5xl lg:text-7xl font-bold text-red-900 font-serif leading-tight">
            Frequently Asked
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-red-800 via-orange-700 to-red-800">
              Questions
            </span>
          </h2>
        </motion.div>

        {/* FAQ Items */}
        <div className="space-y-2 sm:space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={faq.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gradient-to-br from-red-900/20 via-orange-800/15 to-red-900/20 rounded-md sm:rounded-xl border border-red-600/20 shadow-md sm:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-3 py-2 sm:px-6 sm:py-4 flex items-center justify-between text-left hover:bg-red-800/10 transition-all"
              >
                {/* Number + Question */}
                <div className="flex items-center gap-2 sm:gap-4 flex-1 pr-2 sm:pr-4">
                  <div className="w-5 h-5 sm:w-9 sm:h-9 bg-gradient-to-br from-red-700 to-red-800 rounded-md flex items-center justify-center">
                    <span className="text-yellow-100 font-bold text-[10px] sm:text-sm">{String(faq.id).padStart(2, '0')}</span>
                  </div>
                  <h3 className="text-xs sm:text-lg lg:text-xl font-bold text-red-900 leading-snug">
                    {faq.question}
                  </h3>
                </div>

                {/* Toggle Arrow */}
                <div className={`w-5 h-5 sm:w-8 sm:h-8 bg-gradient-to-br from-red-600 to-red-700 rounded-full flex items-center justify-center transform transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`}>
                  <svg className="w-2.5 h-2.5 sm:w-4 sm:h-4 text-yellow-100" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>

              {/* Answer */}
              <motion.div
                initial={false}
                animate={{ height: openFAQ === index ? 'auto' : 0, opacity: openFAQ === index ? 1 : 0 }}
                transition={{ duration: 0.3, ease: 'easeInOut' }}
                className="overflow-hidden"
              >
                <div className="px-3 sm:px-6 pb-3 sm:pb-6">
                  <div className="ml-7 sm:ml-12">
                    <div className="bg-gradient-to-r from-orange-100/80 via-yellow-50/80 to-orange-100/80 rounded-md sm:rounded-lg p-3 sm:p-6 border-l-4 border-red-600">
                      <p className="text-red-900/90 leading-relaxed text-xs sm:text-base">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
